import { Grid, Typography, Chip } from "@material-ui/core"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import { getStatusColor } from "../../../utils/helperFunctions"
import { Skeleton } from "@material-ui/lab"

const useStyles = makeStyles((theme) => ({
	header: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		padding: theme.spacing(2, 0),
	},
	headerTitle: {
		padding: theme.spacing(1, 0),
	},
}))

const TitleSection = (props) => {
	const { title, name, status, isLoading, actionItems } = props
	const classes = useStyles()
	const theme = useTheme()
	return (
		<>
			<Grid container item xs={12} data-testid="title-section" className={classes.header}>
				<Grid item container xs={5} direction="column">
					<Grid item xs={8}>
						<Typography variant="subtitle2" className={classes.headerTitle}>
							{title}
						</Typography>
					</Grid>
					{!isLoading ? (
						<Grid container item alignItems="center" direction="row" xs={12}>
							<Grid item>
								<Typography variant="h5" className={classes.headerTitle}>
									{name}
								</Typography>
							</Grid>
							{status ? (
								<Grid item>
									<Chip
										label={status}
										size="small"
										style={{
											textTransform: "capitalize",
											color: getStatusColor(status, theme).color,
											backgroundColor: getStatusColor(status, theme).background,
											marginLeft: "16px",
										}}
									/>
								</Grid>
							) : null}
						</Grid>
					) : (
						<Skeleton width="250px" />
					)}
				</Grid>
				{actionItems}
			</Grid>
		</>
	)
}

export default TitleSection
